import React, { Fragment, useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useParams } from "react-router-dom";
import { Tab, Nav } from "react-bootstrap";
import { currentUser } from '../../../../store/selectors/CurrentUserSelector';
import Traitements from './TraitementsTable/Traitements';
import Dashboard from './Dashboard';
import HistoriqueMedical from './HistoriqueMedical';
import Parametres from './Parametres';
import DossierAnalyses from './DossierAnalysesTable/DossierAnalyses';
import PiecesJointes from './PiecesJointesTable/PiecesJointes';
import Antecedents from './Antecedents';

const VoletMedicalPane = (props) => {
    const {dossierDatas} = props;
    const { id } = useParams();
    const dispatch = useDispatch();
    
    const tabData = [
        {
          name: 'Dashbord',
          icon: 'chalkboard',
          component: Dashboard,
        },
        {
          name: 'Consultations',
          icon: 'notes-medical',
          component: HistoriqueMedical,
        },
        {
          name: 'Paramètres',
          icon: 'heartbeat',
          component: Parametres,
        },
        {
          name: 'Traitements',
          icon: 'pills',
          component: Traitements,
        },
        {
          name: 'Antécédents',
          icon: 'diagnoses',
          component: Antecedents,
        },
        {
          name: 'Pièces Jointes',
          icon: 'paperclip',
          component: PiecesJointes,
        },
        {
          name: 'Analyse',
          icon: 'procedures',
          component: DossierAnalyses,
        },
        /*{
          name: 'Vaccins',
          icon: 'syringe',
          component: Traitements,
        },*/
      ];



    return (
        <Fragment>
            <div className='custom-tab-1'>
                <Tab.Container defaultActiveKey={tabData[0].name.toLowerCase()}>
                    <Nav as='ul' className='nav-tabs'>
                    {tabData.map((data, i) => (
                        <Nav.Item as='li' key={i}>
                        <Nav.Link eventKey={data.name.toLowerCase()}>
                            <i className={`la la-${data.icon} mr-2`} />
                            {data.name}
                        </Nav.Link>
                        </Nav.Item>
                    ))}
                    </Nav>
                    <Tab.Content className='pt-4'>
                    {tabData.map((data, i) => (
                        <Tab.Pane eventKey={data.name.toLowerCase()} key={i}>
                            <data.component datas={dossierDatas} />
                        </Tab.Pane>
                    ))}
                    </Tab.Content>
                </Tab.Container>
            </div>
        </Fragment>
    )
}

const mapStateToProps = (state) => {
    return {
        provider: state.provider.provider,
        currentUser: currentUser(state)
    };
};

export default connect(mapStateToProps)(VoletMedicalPane);